import type { IEmailRepository } from '../../domain/repositories/IEmailRepository';

interface WelcomeEmailParams {
  userId: string;
  userEmail: string;
  userName: string;
  userRole: string;
  workspaceId: number;
}

export class SendWelcomeEmailUseCase {
  constructor(private readonly emailRepository: IEmailRepository) {}

  async execute(params: WelcomeEmailParams): Promise<{ success: boolean; error?: string }> {
    return this.emailRepository.sendWelcomeEmail(
      params.userId,
      params.userEmail,
      params.userName,
      params.userRole,
      params.workspaceId
    );
  }
}
